import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { useDispatch } from "react-redux";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import { GetMerchants } from "src/merchants/actions/MerchantActionCreators";
import type { Merchant } from "src/merchants/objects/Merchant";

export type UseMerchantsOptions = UseQueryOptions<
  Merchant[],
  unknown,
  Merchant[],
  ["merchants", "merchantGroupUuid", string | null | undefined]
>;

export const useMerchants = (
  merchantGroupUuid?: string | null,
  options?: UseMerchantsOptions,
) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  return useQuery(
    ["merchants", "merchantGroupUuid", merchantGroupUuid],
    async () => {
      return await dispatch(GetMerchants(merchantGroupUuid ?? undefined));
    },
    options,
  );
};
